import "src/pages/Treasury/TreasuryPlatformManagement/QueryPaymentBatch/styles_vanilla.css.ts.vanilla.css!=!../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/pages/Treasury/TreasuryPlatformManagement/QueryPaymentBatch/styles_vanilla.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA81U0U7DIBR931fcxJhoIgt0WzfZ17ACLa4FpMzVGP_dQNeuNZtRUxObvrSce-65hwNz9awt9hjeZgBHxX1BgWB8u50BFELlhe--32fzFksi1jLOlc4pJEvbBPTOOC4c2hnvTUWB2AZqUyoONzKRRMiIYdk-d-agOcpMaRyFGxmfAX0S6SvmcqUp4FDWYRNMJMkG2EXEylI0FMi1BmuZylVYNC_CydIcKbCDN9tLQ3BV25K90si5PXEjrpzIvDKaBimHSoeVnNmurtezjHq-mLKz6Zo_rYeOcXWoKWxaUb3KRdJZ3aC6YDyMgiPTwjbg8h27ww9weufkPmC9aDxipcqDeKG9cAO9q7HXgSy1zWXTAaTRHh1PoUgxHhClkagrWSdrkorteBt77PpvTTrn8bsm9co2U9nxGIl-GqbQbEDCLp3JijXo9GuF8Qi_i_i41agWpWz7otoz52Op0l1p8qk0m0Ivn8o9MYUa-W9Tlk_lU_ErnzYjm9RljjOyS5TyoqrHkepJnq6c_pH2FcafUkiW2J4V14VTet9eFR93jdV3lgYAAA\"}!../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var cardContent = 'iqnp0th';
export var cardTitle = 'iqnp0tg';
export var cardsContainer = 'iqnp0te';
export var container = 'iqnp0t0';
export var contentArea = 'iqnp0t3';
export var fieldLabel = 'iqnp0tj';
export var fieldRow = 'iqnp0ti';
export var form = 'iqnp0t9';
export var formCard = 'iqnp0t7';
export var formTitle = 'iqnp0t8';
export var header = 'iqnp0t1';
export var pageTitle = 'iqnp0t2';
export var placeholderDescription = 'iqnp0t6';
export var placeholderSection = 'iqnp0t4';
export var placeholderTitle = 'iqnp0t5';
export var resultCard = 'iqnp0tf';
export var resultsSection = 'iqnp0tc';
export var resultsTitle = 'iqnp0td';
export var submitButton = 'iqnp0tb';
export var textInput = 'iqnp0ta';